interface IEmailValidate {
  msg: string;
  status: boolean;
}

function reg(str: string, rStr: string) {
  const regs = new RegExp(rStr);
  return regs.test(str);
}

// input防止sql
export function preSql(str: string) {
  const re =
    /(\bselect\b|\binsert\b|\bhttp\b|\bupdate\b|\bdelete\b|\bscript\b|\bexec\b|\bcount\b|’|"|=|;|>|<|%)/i;
  return !re.test(str.toLowerCase());
}
// ip地址正则
export function isValidIP(ip: string) {
  const regs =
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  return regs.test(ip);
}

// 用户设置昵称不能输入中文，nickName校验规则
export function nickNameValidate(userName: string) {
  const myReg = /^[a-zA-Z0-9_]{0,}$/;
  let obj: { msg: string; status: boolean } = { msg: '', status: false };
  if (userName) {
    if (!myReg.test(userName)) {
      obj = {
        msg: 'Username has to be within 5-20 characters, special characters are not allowed',
        status: false,
      };
    } else if (userName.length < 5 || userName.length > 20) {
      obj = {
        msg: 'Username has to be within 5-20 characters, special characters are not allowed',
        status: false,
      };
    } else {
      obj = {
        msg: '',
        status: true,
      };
    }
  } else {
    obj = {
      msg: 'Username has to be within 5-20 characters, special characters are not allowed',
      status: false,
    };
  }
  return obj;
}

// 密码气泡框校验
export function passwordValidate(password: string) {
  if (!password) password = '';
  const rc = {
    uW: '[A-Z]',
    nW: '[0-9]',
    lW: '[a-z]',
  };
  const lengthValidate = password.length >= 8 && password.length <= 30;
  const upperCaseValidate = reg(password, rc.uW);
  const numberValidate = reg(password, rc.nW);
  const lowercaseValidate = reg(password, rc.lW);
  return {
    lengthValidate,
    upperCaseValidate,
    numberValidate,
    lowercaseValidate,
    allValid:
      lengthValidate &&
      upperCaseValidate &&
      numberValidate &&
      lowercaseValidate,
  };
}

// 密码校验
export function passwordVal(password: string) {
  if (!password) password = '';
  const rc = {
    uW: '[A-Z]',
    nW: '[0-9]',
  };
  const lengthValidate = password.length >= 8 && password.length <= 30;
  const upperCaseValidate = reg(password, rc.uW);
  const numberValidate = reg(password, rc.nW);
  return {
    lengthValidate,
    upperCaseValidate,
    numberValidate,
    allValid: lengthValidate && upperCaseValidate && numberValidate,
  };
}

// 手机号码验证
export function phoneValidate(str: string) {
  return !(str.length > 12 || str.length < 5);
}

// 密码验证
export function passTest(
  str: string,
  account: string,
  flag?: boolean | string,
) {
  const rC = {
    lW: '[a-z]',
    uW: '[A-Z]',
    nW: '[0-9]',
    sW: '[\\u0020-\\u002F\\u003A-\\u0040\\u005B-\\u0060\\u007B-\\u007E]',
  };
  if (!str) {
    return {
      msg: 'Please enter a password',
      status: false,
    };
  }
  if (str.length < 8) {
    return {
      msg: 'Password has to be between 8-30 characters, and contains at least one uppercase letter, one lowercase letter and a number',
      status: false,
    };
  }
  if (str.indexOf(account) >= 0 && !flag) {
    return {
      msg: 'Psd without account',
      status: false,
    };
  }
  if (str.length >= 8 && str.length <= 30) {
    const tR = {
      l: reg(str, rC.lW),
      u: reg(str, rC.uW),
      n: reg(str, rC.nW),
      s: reg(str, rC.sW),
    };
    if (tR.l && tR.n && tR.u) {
      return {
        msg: '',
        status: true,
      };
    }
    return {
      msg: 'Password has to be between 8-30 characters, and contains at least one uppercase letter, one lowercase letter and a number',
      status: false,
    };
  }
  return {
    msg: 'Password has to be between 8-30 characters, and contains at least one uppercase letter, one lowercase letter and a number',
    status: false,
  };
}

// 邮箱验证
export function emailValidate(str: string) {
  // eslint-disable-next-line no-useless-escape
  const regs = /([\w\-]+\@[\w\-]+\.[\w\-]+)/;
  let obj: IEmailValidate = {
    msg: '',
    status: false,
  };
  if (!regs.test(str)) {
    obj = {
      msg: 'Invalid email address',
      status: false,
    };
  } else {
    obj = newEmailValidate(str);
  }
  return obj;
}

// 新的邮箱验证
export function emailValidateNew(str: string) {
  const regs =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let obj: IEmailValidate = {
    msg: '',
    status: false,
  };

  if (!regs.test(str)) {
    obj = {
      msg: 'Invalid email address',
      status: false,
    };
  } else {
    obj = newEmailValidate(str);
  }
  return obj;
}

// 新邮箱验证方法
export function newEmailValidate(str: string) {
  return {
    msg: '',
    status: true,
  };

  // const regs =
  //   /^([a-z\dA-Z]+[-|_\\.]?)+[a-z\dA-Z]@([a-z\dA-Z]+(-[a-z\dA-Z]+)?\.)+[a-zA-Z]{2,}$/;
  // const zhCNEmail = [
  //   'qq.com',
  //   '163.com',
  //   '126.com',
  //   'sina.com',
  //   'sina.com.cn',
  //   'sina.cn',
  //   '189.com',
  //   '139.com',
  //   'aliyun.com',
  //   '21cn.com',
  //   'yeah.com',
  //   'letv.com',
  //   '188.com',
  //   'foxmail.com',
  //   'sohu.com',
  //   'wo.cn',
  // ];

  // const emailSuffix = str.slice(str.indexOf('@') + 1) || '';
  // let obj: IEmailValidate = {
  //   msg: '',
  //   status: false,
  // };

  // if (zhCNEmail.includes(emailSuffix)) {
  //   obj = {
  //     msg: 'notSupportCN',
  //     status: false,
  //   };
  // } else {
  //   obj = {
  //     msg: '',
  //     status: true,
  //   };
  // }
  // return obj;
}

// 链接验证
export function hrefValidate(str: string) {
  const reg = /[a-zA-z]+:\/\/[^\s]*/;
  let obj: IEmailValidate = {
    msg: '',
    status: false,
  };
  if (reg.test(str)) {
    obj = {
      msg: '',
      status: true,
    };
  } else {
    obj = {
      msg: '',
      status: false,
    };
  }
  return obj;
}

// 验证注册密码
export function validatePassWord(password: string) {
  const isMatch = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,30}$/.test(password);
  return isMatch;
}

// 合法的 bybit.com 站 url
export function isValidBybitHostUrl(url: string) {
  const reg = /^(https:\/\/)(.*\.bybit\.com)[\S.-/?]+$/;

  return reg.test(url);
}
